/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;text-align:center;padding:0 20px}.title[_ngcontent-%COMP%]{color:var(--text-color,#000);font-weight:700}.pre[_ngcontent-%COMP%]{color:var(--text-color,#333);line-height:25px;font-size:16px;margin:21px 0 26px}"];
export { styles as styles };
